import { Component } from '@angular/core';
import { combineLatest, filter, map, tap } from 'rxjs';
import { GtmEvent } from 'src/app/interfaces/gtm.interface';
import { InitialParametersUI } from 'src/app/interfaces/initial-parameters.interface';
import { TextModalContentUI } from 'src/app/interfaces/text-modal.interface';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { MedalliaService } from 'src/app/services/medallia/medallia.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { StoreService } from 'src/app/services/store/store.service';
import { ModalContentKey } from 'src/app/utils/enums';

@Component({
	selector: 'app-generic-modal',
	templateUrl: './generic-modal.component.html',
	styleUrls: ['./generic-modal.component.scss'],
})
export class GenericModalComponent {
	readonly vm$ = combineLatest({
		modalText: this.modalService.modalText$,
		params: this.storeService.initialParameters$,
	}).pipe(
		filter(
			(
				vm
			): vm is {
				modalText: TextModalContentUI;
				params: InitialParametersUI;
			} => vm.modalText != null && vm.params != null
		),
		tap(({ modalText, params }) => {
			this.handleModalSpecificAction(modalText.type, params.nameLeakSurvey);
			if (modalText.tags?.page) this.gtmService.handlerEvent(modalText.tags.page);
		}),
		map(({ modalText }) => modalText)
	);

	private deleteCloseGtm = false;

	constructor(
		private readonly modalService: ModalService,
		private readonly storeService: StoreService,
		private readonly medalliaService: MedalliaService,
		private readonly gtmService: GtmService
	) {}

	onButtonActionHandler(action?: string, gtmAction?: GtmEvent): void {
		if (gtmAction) {
			this.gtmService.handlerEvent(gtmAction);
			this.deleteCloseGtm = true;
		}

		if (action) window.location.assign(action);
		this.modalService.closeModal();
	}

	private handleModalSpecificAction(type: ModalContentKey, nameLeakSurvey: string): void {
		if (type === ModalContentKey.ABANDON_MODAL) {
			this.medalliaService.showLeakSurvey(nameLeakSurvey);
		}
	}

	onEventCloseModal(defaultGtm?: GtmEvent) {
		if (!this.deleteCloseGtm && defaultGtm) this.gtmService.handlerEvent(defaultGtm);
		this.deleteCloseGtm = false;
	}
}
